export default __webpack_public_path__ + "static/9_19-6143bd5c2aa1ccff0e42e7104d7a17f9.png";